var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgT = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "5.25rem",
  height: "5.25rem",
  "data-name": "Group 42",
  viewBox: "0 0 167 201.25"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "T_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h167v201.25H0z",
  "data-name": "Rectangle 36",
  style: {
    fill: "none"
  }
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 41",
  style: {
    clipPath: "url(#T_svg__a)"
  }
}, /*#__PURE__*/React.createElement("path", {
  d: "M5 55.75a2.5 2.5 0 0 1-2.5-2.5v-13a2.5 2.5 0 0 1 2.5-2.5h11.942L21.15 27.7a25.92 25.92 0 0 1 24.015-15.95h.6A11.67 11.67 0 0 1 57.157 2.5h9.686a11.68 11.68 0 0 1 11.407 9.25h44.361a25.92 25.92 0 0 1 24.017 15.95l4.206 10.045H162a2.5 2.5 0 0 1 2.5 2.5v13a2.5 2.5 0 0 1-2.5 2.5z",
  "data-name": "Path 133",
  style: {
    fill: "#fff"
  }
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M66.842 5A9.16 9.16 0 0 1 76 14.158v.092h46.61a23.47 23.47 0 0 1 21.71 14.416l4.849 11.584H162v13H5v-13h13.606l4.85-11.584A23.47 23.47 0 0 1 45.165 14.25H48v-.092A9.16 9.16 0 0 1 57.157 5zm0-5h-9.685a14.18 14.18 0 0 0-13.291 9.279A28.4 28.4 0 0 0 18.84 26.743l-3.561 8.507H5a5 5 0 0 0-5 5v13a5 5 0 0 0 5 5h157a5 5 0 0 0 5-5v-13a5 5 0 0 0-5-5h-9.5l-3.565-8.515A28.41 28.41 0 0 0 122.61 9.25H80.123A14.18 14.18 0 0 0 66.842 0",
  "data-name": "Path 134"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M147.1 53.25h-127l14 148h99z",
  "data-name": "Path 135"
})), /*#__PURE__*/React.createElement("path", {
  d: "M123.16 127.393a39.041 39.041 0 1 1-39.041-39.04 39.04 39.04 0 0 1 39.041 39.04",
  "data-name": "Path 136",
  style: {
    fill: "#fff"
  }
}), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "m94.443 115.348-15.288 27.34a4.7 4.7 0 0 0 3.951 6.977 22.294 22.294 0 0 0 19.35-34.6 4.7 4.7 0 0 0-8.013.287",
  "data-name": "Path 137"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M88.657 112.32a4.68 4.68 0 0 0-3.967-6.978c-7.814-.081-16.085 3.751-20.239 11.18s-3.087 16.48 1.073 23.1a4.68 4.68 0 0 0 8.022-.273z",
  "data-name": "Path 138"
}))));
export default SvgT;